import { render, staticRenderFns } from "./WaybillIncomeStatement.vue?vue&type=template&id=faacb960&scoped=true&"
import script from "./WaybillIncomeStatement.vue?vue&type=script&lang=js&"
export * from "./WaybillIncomeStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faacb960",
  null
  
)

export default component.exports